import { objectToTranslatableChoices } from '@shared/choice';
import { ChargeTypology } from '@shared/types/api/charge';
export const CHARGE_TYPOLOGY_TRAD_KEYS = {
    [ChargeTypology.ExpertiseFees]: 'claim.charge.typology.expertise_fees',
    [ChargeTypology.RikFees]: 'claim.charge.typology.rik_fees',
    [ChargeTypology.LeakageDetectionFees]: 'claim.charge.typology.leakage_detection_fees',
    [ChargeTypology.SecuringFees]: 'claim.charge.typology.securing_fees',
    [ChargeTypology.OtherFees]: 'claim.charge.typology.other_fees',
};
export const CHARGE_TYPOLOGY_CHOICES = objectToTranslatableChoices(CHARGE_TYPOLOGY_TRAD_KEYS);
